import { DEPLOY_ENV } from '@/config';

export function getSegmentWriteKey() {
  return DEPLOY_ENV === 'production' ? 'aT4xk07lZ10GdWYrhoepcCRgtejDGSU3' : 'nYiZ5B7iBfeu1AeSKOrF4XjZ0oJQH92F';
}
